/* global localStorage:false, swal:false */
(function () {
  "use strict";

  angular
    .module("admin.communities.post_hidden.service", [])
    .factory("CommunitiesPostsHiddenService", CommunitiesPostsHiddenService);

  /** @ngInject */
  function CommunitiesPostsHiddenService($http, $q, API) {
    function list(start, limit) {
      var defer = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/community_posts?start=" +
            start +
            "&limit=" +
            limit +
            "&sort=id-desc" +
            "&hidden=true"
        )
        .success(defer.resolve);

      return defer.promise;
    }

    return {
      list: list,
    };
  }
})();
